import React, {useRef} from "react";
import {useNavigate, useParams} from "react-router-dom";
import useChatbot from "@/query/chatbot/useChatbot";
import {Card, CardContent, CardFooter, CardHeader, CardTitle} from "@/components/ui/card";
import {Label} from "@/components/ui/label";
import {Button} from "@/components/ui/button";
import toast from "react-hot-toast";
import useUpdateChatbot from "@/query/chatbot/useUpdateChatbot";
import {WorkflowChatHandlerComboBoxRef, WorkflowComboBox} from "@/view/chatbot/ChatHandlerCombobox";
import {Chatbot, ChatbotUpdate} from "@/model/Chatbot";
import {ChevronLeftIcon} from "@heroicons/react/24/outline";

const ChatbotDetailView = () => {
    const {chatbotId} = useParams() as { chatbotId: string };

    const {data: chatbot} = useChatbot(chatbotId)

    if (!chatbot) return null

    return <Content chatbot={chatbot}/>

}

const Content: React.FC<{ chatbot: Chatbot }> = ({chatbot}) => {

    const navigate = useNavigate();

    const chatHandlerRef = useRef<WorkflowChatHandlerComboBoxRef>(null)
    const keywordClusterRef = useRef<WorkflowChatHandlerComboBoxRef>(null)
    const welcomeHandlerRef = useRef<WorkflowChatHandlerComboBoxRef>(null)

    // const [chatHandler, setChatHandler] = useState<WorkflowHandler | undefined>(chatbot.chatHandler)
    // const [welcomeHandler, setWelcomeHandler] = useState<WorkflowHandler | undefined>(chatbot.welcomeHandler)

    const {mutateAsync: update, isLoading} = useUpdateChatbot(chatbot._id)

    const onSubmit = async () => {
        if (!chatHandlerRef.current || !welcomeHandlerRef.current || !keywordClusterRef.current || isLoading) return

        const body: ChatbotUpdate = {chatbotClusterId: chatbot.clusterId}

        const chatWorkflow = chatHandlerRef.current.chatHandler()
        const welcomeWorkflow = welcomeHandlerRef.current.chatHandler()
        const keywordClusterWorkflow = keywordClusterRef.current.chatHandler()

        if (!chatWorkflow) {
            toast.error("Chat Handler 설정이 필요합니다.")
            return
        }

        if (!welcomeWorkflow) {
            toast.error("Welcome Handler 설정이 필요합니다.")
            return
        }

        if (!keywordClusterWorkflow) {
            toast.error("Keyword Cluster Handler 설정이 필요합니다.")
            return
        }

        if (chatbot.chatHandler) {
            body.chatHandler = {...chatbot.chatHandler, workflowId: chatWorkflow._id}
        }

        if (chatbot.welcomeHandler) {
            body.welcomeHandler = {...chatbot.welcomeHandler, workflowId: welcomeWorkflow._id}
        }

        if (chatbot.keywordClusterHandler) {
            body.keywordClusterHandler = {...chatbot.keywordClusterHandler, workflowId: keywordClusterWorkflow._id}
        }


        try {
            await update(body)
            toast.success("저장")
        } catch (e) {
            toast.error("실패")
        }
    }

    const onClickBack = (e: React.MouseEvent) => {
        e.preventDefault();
        navigate(-1);
    };

    return (
        <div className='p-2'>
            <div className='flex justify-between nitems-center mb-2'>
                <div className="flex items-center space-x-[10px]">
                    <button onClick={onClickBack}>
                        <ChevronLeftIcon className="w-6 h-6"/>
                    </button>
                    <div>
                        {chatbot.name}
                    </div>
                </div>
                <Button variant="outline" onClick={() => navigate(`/chatbots/${chatbot._id}/chat`)}>Go Chat</Button>
            </div>

            <Card>
                <CardHeader>
                    <CardTitle></CardTitle>
                    {/*<CardDescription>...</CardDescription>*/}
                </CardHeader>
                <CardContent className='grid gap-4'>
                    <div className="w-full items-center gap-4 flex ">
                        <div className='flex gap-3 items-center'>
                            <div className='flex gap-3 items-center'>
                                <Label htmlFor="framework">Chat Handler </Label>
                                <WorkflowComboBox defaultWorkflowId={chatbot.chatHandler?.workflowId}
                                                  ref={chatHandlerRef} labels={['sitebunny-chat']}/>
                            </div>
                        </div>
                    </div>

                    <div className="w-full items-center gap-4 flex ">
                        <div className='flex gap-3 items-center'>
                            <div className='flex gap-3 items-center'>
                                <Label htmlFor="framework">Keyword Cluster Handler </Label>
                                <WorkflowComboBox defaultWorkflowId={chatbot.keywordClusterHandler?.workflowId}
                                                  ref={keywordClusterRef} labels={['sitebunny-keyword-cluster']}/>
                            </div>
                        </div>
                    </div>

                    <div className="w-full items-center gap-4 flex ">
                        <div className='flex gap-3 items-center'>
                            <Label htmlFor="framework">Welcome Handler </Label>
                            <WorkflowComboBox defaultWorkflowId={chatbot.welcomeHandler?.workflowId}
                                              ref={welcomeHandlerRef}
                                              labels={['sitebunny-welcome']}/>
                        </div>
                    </div>

                </CardContent>
                <CardFooter className="flex justify-end">
                    <Button disabled={isLoading} onClick={onSubmit}>저장</Button>
                </CardFooter>
            </Card>
        </div>
    )
}


export default ChatbotDetailView